import store from '../../store';
import { mensagemAlertaActions } from '../../features/mensagemAlerta/redux';
import { mensagemErroPadrao } from './Constantes';

export async function handleRequestError(error) {
  let mensagem = error.response && error.response.data && error.response.data.mensagem;

  if (error.response.data instanceof Blob){
    let data = JSON.parse(await error.response.data.text());
    mensagem = data.mensagem;
  }
  else if (error.response.data instanceof ArrayBuffer){
    const decoder = new TextDecoder();
    let data = decoder.decode(error.response.data);

    try {
      let temp = JSON.parse(data);
      data = temp.mensagem;
    } catch(e) {}

    mensagem = data;
  }

  if((error.response && error.response.status === 404) && !mensagem) {
    return Promise.reject(error);
  }

  store.dispatch(mensagemAlertaActions.exibirNotificacao(mensagem || mensagemErroPadrao));
  return Promise.reject(error);
}

export function baixarArquivo(resposta, nomeArquivo, abrirNovaAba = false) {

  if (!resposta || !resposta.data) return;
  if (!nomeArquivo) nomeArquivo = resposta.headers['x-file-name'];
  
  const arquivo = new Blob([resposta.data], { type: resposta.headers["content-type"] });

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(arquivo, nomeArquivo);
  } else {
    const arquivoURL = URL.createObjectURL(arquivo);

    if (abrirNovaAba) {
      return arquivoURL;
    }
    else {
      const link = document.createElement("a");
      
      link.href = arquivoURL;
      link.setAttribute("download", nomeArquivo);
      
      document.body.appendChild(link);
      link.click();
    }
  }
}
